<!-- <div class="follow_btnbase btn-group mr-1" style="height:40px;"> -->
<button
  mat-button
  *ngIf="
    (!this.userState.userDetails?.userType || authorizeService.canView('watchlistGroup')) &&
    !(appState?.companyInfoValue?.alias === 'opscan')
  "
  (click)="openFavoriteModel()"
>
  <mat-icon inline="true">favorite</mat-icon>
  <span class="ml-2">Add to Watchlist</span>
</button>
<!-- <div class="btn-group followDropdown" ngbDropdown #followDropDown="ngbDropdown" [placement]="'bottom-right'"
    role="group" aria-label="Button group with nested dropdown" id="followDropDown" [autoClose]="true">
    <button matRipple class="btn btn-secondary follow_btn dropdown-toggle-split" id="follow_btnArea"
      (click)="openDropdown()" ngbDropdownAnchor name="open watchlist" tabindex="7" name="open recent watch list"
      aria-label="open recent watch list">
    </button>
    <div class="dropdown-menu dropdown-menu-right followed_drop" ngbDropdownMenu aria-labelledby="follow_btnArea">
      <div class="fldlist">
        <button mat-button class="submenu_close" id="savepop_btn" ngbDropdownToggle tabindex="7" name="close watchlist"
          aria-label="close watch list"></button>
        <div *ngIf="hideCreateGroupOption">
          <p class="headname mt-0 mb-2">{{stringRes.RECENT_WATCH_LIST | titlecase}} </p>
          <span class="dropdown-item22" style="background-color: #fff;">
            <mat-form-field appearance="outline">
              <mat-label>Search</mat-label>
              <input placeholder="{{stringRes.WATCH_LIST_NAME}}" autocomplete="off" matInput name="followFilterInput"
                [(ngModel)]="followFilterInput" tabindex="7" aria-label="search watch list">
            </mat-form-field>
          </span>
        </div>
        <ul class="list-group cust_check2"
          *ngIf="(favoriteState.followGroupList$ | async | followedPropertyFilter:followFilterInput ) as result">
          <div style="max-height:178px;overflow: auto;" class="followGroupsList"
            *ngIf="result.length && hideCreateGroupOption">
            <li *ngFor="let property of $any(result) | slice:0:5; let i= index">
              <label class="btn-block cursor" [matTooltip]="$any(property).name">
                <mat-checkbox color="primary" [(ngModel)]="$any(property).checked" (change)="isGroupSelected(result)"
                  tabindex="7">
                  <span class="truncated ml-0"> {{ $any(property).name }}
                  </span>
                </mat-checkbox>
              </label>
              <i class="fa fa-trash" aria-hidden="true" *ngIf="$any(property).mode!=='Default'"
                (click)="deleteGroup($any(property).id)" tabindex="7" aria-label="delete"
                (keydown.enter)="deleteGroup($any(property).id)"></i>
            </li>
          </div>
          <div class="alert alert-warning mt-3 f1em" *ngIf="!result.length">
            No result found
          </div>
          <div class="clearfix buttonWrap">
            <div class="followedGroupInput" *ngIf="!hideCreateGroupOption ">
              <div class="fldcreate_base" style="margin-top: -16px;" id="fldcrt">
                <p class="mb-1">Enter {{stringRes.WATCH_LIST | lowercase}} name</p>
                <form>
                  <div class="form-group mb-1">
                    <input type="text" name="newGroupName" class="form-control" [(ngModel)]="groupName"
                      autocomplete="off" />
                  </div>
                  <button class="btn submit_btn blue_btn pt-1 pb-1 pl-3 pr-3" [disabled]="!groupName"
                    (click)="createNewFollowGroup(groupName)">Save</button>
                  <button class="btn submit_btn line_btn pt-1 pb-1 pl-3 pr-3 ml-1" id="close_crt"
                    (click)="hideCreateGroupOption = true; groupName = ''">Cancel</button>
                </form>
              </div>
            </div>
            <button *ngIf="selectedGroups && selectedGroups.length > 0 && hideCreateGroupOption"
              class=" btn btn_100 text-white">
              <div (click)="favoriteProperties('dropdown')"
                [matBadge]="(selectedGroups && selectedGroups.length) ? selectedGroups.length.toString() : ''">
                {{stringRes.SAVE_TO_WATCH_LIST}}
              </div>
            </button>
            <div *ngIf="hideCreateGroupOption">
              <a matRipple *ngIf="selectedGroups && selectedGroups.length === 0" class="btn btn_100 text-white"
                (click)="hideCreateGroupOption = false;groupName = ''" id="crt_grp">+
                &nbsp; {{stringRes.CREATE_WATCH_LIST}}</a>
              <a matRipple class="btn mt-1 line_btn btn-block" routerLink="/watchlist"
                *ngIf="result!='' || result.length">
                <span class="show">{{ result.length }} {{stringRes.WATCH_LIST}} </span> <span
                  class="hide">{{stringRes.SHOW_ALL_WATCH_LIST}}</span>
              </a>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div> -->
<!-- </div> -->
